export default __webpack_public_path__ + "static/media/2.2fb0e009.jpg";